{
  "title": "True Seeing",
  "source": "Player's Handbook",
  "levelAndSchool": "6th-level divination",
  "level": 6,
  "castingTime": "1 action",
  "range": "Touch",
  "components": "V, S, M (an ointment for the eyes that costs 25 gp; is made from mushroom powder, saffron, and fat; and is consumed by the spell)",
  "duration": "1 hour",
  "description": [
    "This spell gives the willing creature you touch the ability to see things as they actually are. For the duration, the creature has truesight, notices secret doors hidden by magic, and can see into the Ethereal Plane, all out to a range of 120 feet."
  ],
  "spellLists": ["bard", "cleric", "sorcerer", "warlock", "wizard"]
}
